export default "__VITE_ASSET__Die2LmSw__"